export enum SaleStatusEnum {
  Available = 'available',
  Sold = 'sold',
  UnderOffer = 'underOffer',
}

export enum PostingTypeEnum {
  Sale = 'sale',
  Rent = 'rent',
  Share = 'share',
  All = 'all',
}

export enum RentPeriodPriceTypeEnum {
  Yearly = 'Yearly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Daily = 'Daily ',
}

export enum CommercialTypeEnum {
  Residential = 'residential',
  Commercial = 'commercial',
  Industrial = 'industrial',
}

export enum FinishStatusEnum {
  Finished = 'finished',
  PartlyFinished = 'partlyFinished',
  Furnished = 'furnished',
  PartlyFurnished = 'partlyFurnished',
  Shell = 'shell',
}

export enum GroundRentStatusEnum {
  Perpetual = 'perpetual',
  Limited = 'limited',
}

export enum GroundRentTypeEnum {
  FreeHold = 'freeHold',
  GroundRent = 'groundRent',
}

export enum OrientationTypeEnum {
  North = 'north',
  South = 'south',
  East = 'east',
  West = 'west',
}

export enum ResourceTypeEnum {
  PDF = 'pdf',
  Image = 'image',
}

export enum FieldDataTypeEnum {
  Number = 'number',
  String = 'string',
  Boolean = 'boolean',
}

export enum PropertyAgentRelationshipTypes {
  Agent = 'agent',
  User = ' user',
}

export enum UserTypeEnum {
  User = 'user',
  Agent = 'agent',
  Developer = 'developer',
}

export enum ActivationStatusEnum {
  Registered = 'registered',
  Confirmed = 'confirmed',
}

export enum MobileActivationStatusEnum {
  NotConfirmed = 'notConfirmed',
  Confirmed = 'confirmed',
}

export enum InviteStatusEnum {
  Pending = 'pending',
  Accepted = 'accepted',
  Superseded = 'superseded',
  Rejected = 'rejected',
}

export enum AcceptInvitationEnum {
  Accept = 'accept',
  Reject = 'reject ',
}

export enum PropertyStatusEnum {
  Submitted = 'submitted',
  Approved = 'approved',
  Hidden = 'hidden',
  Premium = 'premium',
  Blocked = 'blocked',
}

export enum PropertyProcessEnum {
  Approve = 'approve',
  Reject = 'reject',
}
